import { render, staticRenderFns } from "./Vulnerabilities.vue?vue&type=template&id=2eddb0ba&"
import script from "./Vulnerabilities.vue?vue&type=script&lang=js&"
export * from "./Vulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports